import { useTranslation } from 'next-i18next';
import { useServices } from '@/context/ServicesProvider';
import React, { useEffect } from 'react';
import { TipoPeriodoTelemetry } from '@/objects/Telemetry';
import TituloSeccionH2 from '@/components/elements/TituloSeccionH2';
import CardDato from '@/components/elements/CardDato';
import { useNotificationContext } from '@/context/NotificationContext';


function TotalLibrosPropios() {
    const { t } = useTranslation();
    const { telemetryQueries } = useServices();
    const { userData } = useNotificationContext();

    const [totalLibrosSubidos, setTotalLibrosSubidos] = React.useState<number>(0);
    const [totalFavoritos, setTotalFavoritos] = React.useState<number>(0);
    const [totalVisitas, setTotalVisitas] = React.useState<number>(0);


    useEffect(() => {
        if (userData == null) return;
        cargarEstadisticas();
    }, [userData]);

    function cargarEstadisticas() {

        telemetryQueries?.obtenerNumeroDeLibrosSubidosByIdUser(userData?.id_user!, TipoPeriodoTelemetry.TOTAL).then((response) => {
            setTotalLibrosSubidos(response.data.total);
        }).catch((error) => {
            console.log('Error al cargar total libros', error);
        });
        telemetryQueries?.obtenerNumeroDeVisitasTotalesByIdUser(userData?.id_user!, TipoPeriodoTelemetry.TOTAL).then((response) => {
            setTotalVisitas(response.data.total);
        }).catch((error) => {
            console.log('Error al cargar total libros hoy', error);
        });
        telemetryQueries?.obtenerNumeroFavoritosPropios(userData?.id_user!).then((response) => {
            setTotalFavoritos(response.data.total);
        }).catch((error) => {
            console.log('Error al cargar total libros mes', error);
        });
    }


    return (
        <section style={{ display: 'flex', flexDirection: 'column', width: '100%' }}>
            {/* <TituloPrincipalH1 texto={t("menu:secciones.mensajes.titulo")} /> */}
            <section style={{ display: 'flex', flexDirection: 'column', alignItems: 'stretch', justifyContent: 'center', width: "100%" }}>
                <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', justifyContent: 'center', width: '100%' }}>
                    <TituloSeccionH2 texto={t("menu:secciones.estadisticas.libros.estadisticas_libros")} />
                </div>

                <div
                    style={{
                        display: 'grid',
                        gridTemplateColumns: 'repeat(auto-fit, minmax(220px, 1fr))',
                        alignItems: 'stretch',
                        width: '100%',
                        maxWidth: '100%',
                        gap: '1em',
                        padding: '1em',
                        boxSizing: 'border-box'
                    }}
                >
                    <div style={{ width: '100%' }}>
                        <CardDato texto={totalLibrosSubidos.toString()} titulo={t("menu:secciones.estadisticas.libros.libros_subidos")} digitAnimated={true} />
                    </div>
                    <div style={{ width: '100%' }}>
                        <CardDato texto={totalFavoritos.toString()} titulo={`${t("menu:secciones.estadisticas.libros.favoritos_total")}`} digitAnimated={true} />
                    </div>
                    <div style={{ width: '100%' }}>
                        <CardDato texto={totalVisitas.toString()} titulo={`${t("menu:secciones.estadisticas.libros.visitas_total")}`} digitAnimated={true} />
                    </div>
                    {/* <div style={{ width: '100%' }}>
                        <CardDato texto={totalLibrosMes.toString()} titulo={`${t("menu:secciones.estadisticas.mes")}`} digitAnimated={true} />
                    </div> */}

                </div>
            </section>
        </section>
    );
}

export default TotalLibrosPropios;